//Custom JS
document.addEventListener("DOMContentLoaded", ()=>{
    const submenuItemsMob = document.querySelectorAll('.js-toggle-custom-submenu')
    submenuItemsMob.forEach(btn=>{
      btn.addEventListener("click", (e)=>{
          e.target.closest('.mobile-nav-wrapper').classList.toggle('sub-nav--is-open')
          e.target.closest('.mobile-nav__item').querySelector('.mobile-nav__dropdown').classList.toggle('is-open')
          e.target.closest('.mobile-nav__custom-wrapper').classList.toggle('is-open')
      })
    })
  })